var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { ContentState, Editor, EditorState, RichUtils, convertFromHTML } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import 'draft-js/dist/Draft.css';
import { FaBold, FaItalic } from 'react-icons/fa';
import { GrOrderedList, GrUnorderedList } from 'react-icons/gr';
import { Form } from 'react-bootstrap';
export const RichTextInput = forwardRef((_a, ref) => {
    var { value, onChange, label, disabled, readOnly } = _a, rest = __rest(_a, ["value", "onChange", "label", "disabled", "readOnly"]);
    const htmlToEditorState = useCallback((html) => {
        const blocksFromHTML = convertFromHTML(html);
        const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
        return EditorState.createWithContent(contentState);
    }, []);
    const [editorState, setEditorState] = useState(() => htmlToEditorState(value));
    useEffect(() => {
        if (!value) {
            setEditorState(EditorState.createEmpty());
        }
    }, [value]);
    const handleEditorChange = (state) => {
        setEditorState(state);
        const contentHTML = stateToHTML(state.getCurrentContent());
        onChange(contentHTML);
    };
    const toggleInlineStyle = (inlineStyle) => {
        handleEditorChange(RichUtils.toggleInlineStyle(editorState, inlineStyle));
    };
    const toggleBlockType = (blockType) => {
        handleEditorChange(RichUtils.toggleBlockType(editorState, blockType));
    };
    const isReadOnly = readOnly || disabled;
    return (_jsxs("div", Object.assign({ ref: ref, className: 'pb-3' }, { children: [_jsx(Form.Label, { children: label }), _jsxs("div", Object.assign({ className: `input-rich-text ${isReadOnly ? 'readonly' : ''}` }, { children: [_jsx(Editor, { editorState: editorState, onChange: handleEditorChange, placeholder: '', readOnly: isReadOnly }), _jsxs("div", Object.assign({ className: 'toolbar', style: {
                            position: 'absolute',
                            bottom: 6,
                            right: 6
                        } }, { children: [_jsx(FaBold, { className: `btn-icon ${isReadOnly ? 'disabled' : ''}`, onClick: !isReadOnly ? () => toggleInlineStyle('BOLD') : undefined }), _jsx(FaItalic, { className: `btn-icon ml-2 ${isReadOnly ? 'disabled' : ''}`, onClick: !isReadOnly ? () => toggleInlineStyle('ITALIC') : undefined }), _jsx(GrOrderedList, { className: `btn-icon ml-2 ${isReadOnly ? 'disabled' : ''}`, onClick: !isReadOnly ? () => toggleBlockType('ordered-list-item') : undefined }), _jsx(GrUnorderedList, { className: `btn-icon ml-2 ${isReadOnly ? 'disabled' : ''}`, onClick: !isReadOnly
                                    ? () => toggleBlockType('unordered-list-item')
                                    : undefined })] }))] }))] })));
});
RichTextInput.displayName = 'RichTextInput';
